import { isSubscriptionPurchase } from '@grandvisionhq/fun-products';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';
import { useCLEcommContext } from '../context/CLEcommContext.js';

/** @deprecated */ const useGetCLLoyaltyPoints = ()=>{
    const { activeVariant: { loyaltyPoints , loyaltyPointsWithSubscription  } ,  } = useProductDetailContext();
    const { state , selectors  } = useCLEcommContext();
    if (!state) return loyaltyPoints // not on a page that uses the CLEcommContext
    ;
    const subscriptionPurchase = isSubscriptionPurchase(state.configurations.purchaseType);
    const clLoyaltyPoints = subscriptionPurchase ? loyaltyPointsWithSubscription : loyaltyPoints;
    // If there is no selected quantity, i.e. both columns are disabled, default to 1
    const totalSelectedQuantity = selectors.getEnabledSelectedQuantity(state) || 1;
    return clLoyaltyPoints ? clLoyaltyPoints * totalSelectedQuantity : clLoyaltyPoints;
};

export { useGetCLLoyaltyPoints };
//# sourceMappingURL=use-get-cl-loyalty-points.js.map
